import { LANGUAGE_CHANGE_EVENT } from '@/core/hooks/useAppLanguage';

export const HEADER_EVENT_NAMES = {
  SEARCH_CLEAR: 'mfe-header-search-clear',
  SEARCH_RESULTS: 'mfe-header-search-results',
  SEARCH_INPUT_FOCUS: 'mfe-header-search-input-focus',
  SEARCH_INPUT_CHANGE: 'mfe-header-search-input-change',
  SEARCH_SELECT: 'mfe-header-search-select',
  BRAND_CLICK: 'mfe-header-brand-click',
  BUTTON_RELOAD: 'mfe-header-button-reload',
  BUTTON_STATUS: 'mfe-header-button-status',
  BUTTON_GUIDE: 'mfe-header-button-guide',
  BUTTON_PROFILE: 'mfe-header-button-profile',
  SIDEBAR_TOGGLE: 'mfe-header-sidebar-toggle',
  CHANGE_LANGUAGE: LANGUAGE_CHANGE_EVENT,
  UPDATE_EXTERNAL_ITEMS: 'mfe-header-update-external-items',
  SEARCH_SUBMIT: 'mfe-header-search-submit',
} as const;
